"use strict";
const _ = require('lodash');
const regions = [
    { zipStart: 10, zipEnd: 12, key: 'region1', localizedName: 'Stockholm' },
    {
        zipStart: 13,
        zipEnd: 19,
        key: 'region2',
        localizedName: 'Storstockholm',
    },
    { zipStart: 20, zipEnd: 22, key: 'region3', localizedName: 'Malmö' },
    {
        zipStart: 23,
        zipEnd: 39,
        key: 'region4',
        localizedName: 'Mellan Malmö och Gbg1',
    },
    {
        zipStart: 43,
        zipEnd: 57,
        key: 'region5',
        localizedName: 'Mellan Malmö och Gbg2',
    },
    { zipStart: 40, zipEnd: 42, key: 'region6', localizedName: 'Göteborg' },
    { zipStart: 58, zipEnd: 61, key: 'region7', localizedName: 'Mälardalen' },
    { zipStart: 62, zipEnd: 62, key: 'region8', localizedName: 'Gotland' },
    {
        zipStart: 63,
        zipEnd: 81,
        key: 'region9',
        localizedName: 'Norr om Stockholm',
    },
    {
        zipStart: 82,
        zipEnd: 93,
        key: 'region10',
        localizedName: 'Södra och mellersta norrland ',
    },
    {
        zipStart: 94,
        zipEnd: 98,
        key: 'region11',
        localizedName: 'Norra norrland',
    },
];
function getAllRegions() {
    return regions;
}
function getRegion(customerSubUnit) {
    if (!customerSubUnit || !customerSubUnit.deliveryZipCode)
        return null;
    const zipcode = customerSubUnit.deliveryZipCode.replace(/\D/g, '');
    if (zipcode.length !== 5) {
        return null;
    }
    const firstTwoDigits = parseInt(zipcode.slice(0, 2), 10);
    const foundRange = regions.find(range => firstTwoDigits <= range.zipEnd && firstTwoDigits >= range.zipStart);
    if (foundRange) {
        return foundRange.key;
    }
    return null;
}
const getQualifyingChainNamesInPriorityOrder = customerSubUnit => {
    const fullChainName = customerSubUnit.chain;
    if (!fullChainName)
        return [];
    const result = [];
    const splitChainName = fullChainName.split('|');
    for (let i = 0; i < splitChainName.length; i++) {
        result.push(_.dropRight(splitChainName, i).join('|'));
    }
    return result;
};
module.exports = {
    getRegion,
    getAllRegions,
    getQualifyingChainNamesInPriorityOrder,
};
